<template>
  <div class="not-found__wrap">
    <div class="col-md-12 not-found-inner">
      <h1 class="not-found__title">
        404
      </h1>
      <p class="not-found__text !tw-text-center">
        {{ $t('notFound.notFoundPage') }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.not-found__wrap{
  position: absolute;
  top: 40%;
  right: 0;
  left: 0;
  .not-found-inner{
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    .not-found__title{
      color: #d0d0d0;
      font-size: 116px;
      font-weight: 700;
      font-family: "Montserrat";
    }
    .not-found__text{
      color: #2d2d2d;
      font-size: 16px;
      font-weight: 600;
    }
  }
}
</style>
